import React from 'react';
import {observer} from 'mobx-react';
import {Modal} from 'shared/components/modals';
import AddReviewee from './AddReviewee';

const AddRevieweeModal = observer((props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      onHide={props.onHide}
      title='performance_reviews.manage.Add participant'>
      <AddReviewee {...props}/>
    </Modal>
  );
});

export default AddRevieweeModal;
